export default __webpack_public_path__ + "static/media/SJA1410.34I-42040_-25193_0.8f4aed8c.jpg";